import React from "react";
import * as CHQ from "chq";

import { useProfile } from "app/context";
import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type NeededApprovalVideoStoryCreatedNotificationProps = {
  notification: CHQ.NeededApprovalNotificationVideoStoryCreated;
};

const isMontage = (
  notification: CHQ.NeededApprovalNotificationVideoStoryCreated
) => notification.notificationType === "needed_approval_video_montage_done";

const NeededApprovalVideoStoryCreatedNotification: React.FC<
NeededApprovalVideoStoryCreatedNotificationProps
> = ({ notification }) => {
  const { profile } = useProfile();
  const user = notification.entity?.creator || profile;

  return (
    <NotificationBody actor={user}>
      <Trans>
        Your video {isMontage(notification) ? "montage" : "story"}{" "}
        was created successfully. It has been sent for
        review to be approved by an admin. For now, you can view it on
        your {user && (
          <ProfileLink user={user}>
            <Trans>profile</Trans>
          </ProfileLink>
        )}.
      </Trans>
      <br />
    </NotificationBody>
  );
};

export default NeededApprovalVideoStoryCreatedNotification;
